import { useState, type ReactNode } from "react";

type Tab = {
  label: string;
  element: ReactNode;
};

type TabsProps = {
  tabs: Tab[];
};

export default function Tabs({ tabs }: Readonly<TabsProps>) {
  const [active, setActive] = useState(tabs[0]);

  const handleClick = (value: Tab) => {
    setActive(value);
  };

  return (
    <div className="flex flex-col w-full">
      <div className="relative inline-flex bg-tab-item/20 rounded-full w-full">
        <div className="absolute top-1 bottom-1 bg-white rounded-full shadow transition-all duration-300" />

        {tabs.map((tab) => (
          <button
            key={tab.label}
            className={`hover:cursor-pointer relative z-10 flex-1 px-4 py-3 text-sm font-medium rounded-full transition-colors ${
              active.label === tab.label
                ? "bg-tab-item text-white"
                : "text-label-dark"
            }`}
            onClick={() => handleClick(tab)}>
            {tab.label}
          </button>
        ))}
      </div>
      <div className="py-6">{active.element}</div>
    </div>
  );
}
